import { z } from 'zod'

export const paramsSchema = z.object({
  id: z.string(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  capacity: z.string().optional(),
})

export type paramsType = z.infer<typeof paramsSchema>
